<template>
  <div class="chartEl">
    <Pie v-if="pieChartData" :data="pieChartData" :options="chartOptionsComputed" />
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import { Pie } from 'vue-chartjs'
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js'

// Register Chart.js components
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend
)

const props = defineProps({
  chartLabels: {
    type: Array,
    required: true
  },
  chartOptions: {
    type: Object,
    default: () => ({})
  },
  chartData: {
    type: Array,
    required: true
  }
})

const pieChartData = ref(null)
const labels = ref([])
const datasets = ref([])

const colour = [
  "#e51313",
  "#13e5e5",
  "#1313e5",
  "#e5e513",
  "#13e513",
  "#efad1e",
  "#e40fc8",
  "#698d2f",
  "#7f2323",
  "#000000"
]

const chartOptionsComputed = computed(() => ({
  responsive: true,
  maintainAspectRatio: true,
  ...props.chartOptions
}))

const setChartData = () => {
  datasets.value = []
  for (let i = 0; i <= props.chartData.length; i++) {
    if (props.chartData[i]) {
      datasets.value.push({
        data: props.chartData[i],
        fill: true,
        backgroundColor: colour[i % 9]
      })
    }
  }
}

const fillData = () => {
  pieChartData.value = {
    labels: labels.value,
    datasets: datasets.value
  }
}

const getData = () => {
  labels.value = props.chartLabels
  setChartData()
}

watch(() => props.chartLabels, () => {
  labels.value = props.chartLabels
  fillData()
})

watch(() => props.chartOptions, () => {
  fillData()
})

watch(() => props.chartData, () => {
  setChartData()
  fillData()
})

onMounted(() => {
  getData()
  fillData()
})
</script>

<style scoped>
.chartEl {
  position: relative;
}
</style>
